module.exports = __webpack_public_path__ + "img/5.b4946558.jpg";